import React from "react";
import classNames from "classnames";
import {GAME_SHOT_CHARTS} from "../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";
import {KeyboardArrowRight} from "../../../icons/keyboard-arrow/keyboard-arrow-right";
import {KeyboardArrowLeft} from "../../../icons/keyboard-arrow/keyboard-arrow-left";
import styles from "./shot-map-shot-selector.module.scss";
import {observer} from "mobx-react";

export const ShotMapShotSelectorForward = observer(({controller, onClick, shouldDisableArrows}) => {
  const {device: {isRtl}} = controller;

  const nextProps = {
    className: classNames(styles.arrow, {[styles.disable_arrow]: shouldDisableArrows}),
    onClick: () => onClick(GAME_SHOT_CHARTS.DIRECTIONS.next)
  }

  return isRtl ? <KeyboardArrowLeft {...nextProps}/> : <KeyboardArrowRight {...nextProps}/>
});